'use client'; // Add this line to make Hero a Client Component


import React, { useCallback, useState } from 'react';
import { useEffect } from 'react';

import Link from 'next/link';
import SvgIcons from '../components/SvgIcons'

import '../app/Homepage.css';
import Image from 'next/image';

import homesw1 from '../components/images/homeswipe/img1.webp'
import homesw2 from '../components/images/homeswipe/img2.webp'
import homesw3 from '../components/images/homeswipe/img3.webp'
import homesw4 from '../components/images/homeswipe/img4.webp'

import img1 from '../components/images/trust_img/image 4.webp'
import img2 from '../components/images/trust_img/image 5.webp'
import img3 from '../components/images/trust_img/image 6.webp'
import img4 from '../components/images/trust_img/image 7.webp'
import img5 from '../components/images/trust_img/image 8.webp'
import user from '../components/images/clean_3.webp'
import rocket from '../components/images/clean_2.webp'
import cer from '../components/images/clean_1.webp'


import certiImage1 from '../components/images/CertifiedImage/certified_img (1).webp'
import certiImage2 from '../components/images/CertifiedImage/certified_img (2).webp'
import certiImage3 from '../components/images/CertifiedImage/certified_img (3).webp'
import certiImage4 from '../components/images/CertifiedImage/certified_img (4).webp'
import certiImage5 from '../components/images/CertifiedImage/certified_img (5).webp'
import certiImage6 from '../components/images/CertifiedImage/certified_img (6).webp'
import certiImage7 from '../components/images/CertifiedImage/certified_img (7).webp'

import HomeBanner1 from '../components/images/home_banner (1).webp'
import HomeBanner2 from '../components/images/home_banner (2).webp'
import HomeBanner3 from '../components/images/home_banner (3).webp'

import gallery_img1 from '../components/images/home_Gallery/home_Gallery (1).webp'
import gallery_img2 from '../components/images/home_Gallery/home_Gallery (2).webp'
import gallery_img3 from '../components/images/home_Gallery/home_Gallery (3).webp'
import gallery_img4 from '../components/images/home_Gallery/home_Gallery (4).webp'
import gallery_img5 from '../components/images/home_Gallery/home_Gallery (5).webp'
import gallery_img6 from '../components/images/home_Gallery/home_Gallery (6).webp'
import gallery_img7 from '../components/images/home_Gallery/home_Gallery (7).webp'
import gallery_img8 from '../components/images/home_Gallery/home_Gallery (8).webp'

import world_img from '../components/images/map.webp'

import cipla from '../components/images/cipla.png'
import cauvery from '../components/images/cauvery.png'
import kia from '../components/images/kia.png'
import saint from '../components/images/saint.png'
import mobis from '../components/images/mobis.png'
import apollo from '../components/images/client/apollo.png'
import Fortis from '../components/images/client/Fortis.png'
import Rela from '../components/images/client/Rela-Logo.webp'
import VHS from '../components/images/client/VHS.png'
import IIT  from '../components/images/client/IIT .png'
import CLRI  from '../components/images/client/CLRI .png'
import BioCon  from '../components/images/client/BioCon .png'
import divis from '../components/images/client/divis-logo.png'
import Aachifoods from '../components/images/client/Aachifoods_logo.jpg'


import { Swiper, SwiperSlide } from 'swiper/react';

// Import Swiper styles
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';

import { Autoplay, Pagination, Navigation, EffectCards } from 'swiper/modules';
import { Testimonials } from './Testimonials';
import { Ourproducts } from './Ourproductscarousels';



const Homepage = () => {
 
  useEffect(() => {
    const elements = document.querySelectorAll('.timer_sec_1 span');

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const span = entry.target as HTMLElement;
            const text = span.textContent || '';
            const match = text.match(/(\d+)/); // Extract numeric part
            const suffix = text.replace(/[\d]+/, ''); // Extract suffix (e.g., "+ Years")

            if (match) {
              const targetNumber = parseInt(match[0], 10); // Numeric value
              let count = 0;
              const increment = targetNumber / 100; // Adjust speed here

              const animateCount = () => {
                if (count < targetNumber) {
                  count += increment;
                  span.textContent = `${Math.floor(count)}${suffix}`; // Update with suffix
                  requestAnimationFrame(animateCount);
                } else {
                  span.textContent = `${targetNumber}${suffix}`; // Ensure it ends correctly
                }
              };

              animateCount();
              observer.unobserve(span); // Stop observing once animated
            }
          }
        });
      },
      { threshold: 0.5 } // Trigger when 50% of the section is in the viewport
    );

    elements.forEach((element) => observer.observe(element));

    return () => observer.disconnect(); // Cleanup
  }, []);


  

  

  return (
  <>
  <div className=" ">
          <Swiper
           spaceBetween={0}
           centeredSlides={true}
           autoplay={{
             delay: 16500,
             disableOnInteraction: false,
           }}
           
           navigation={true}
           modules={[Autoplay, Pagination]}
           className="mySwiper"
//       pagination={{
//         clickable: true,
//         renderBullet: (index, className) => {
//           return `
//             <span class="${className}">
//             <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
//   <path opacity="0.5" d="M3.32565 16.0376C4.29461 17.1088 5.50714 17.931 6.8608 18.4348C8.21447 18.9386 9.6695 19.1092 11.103 18.9322C12.5365 18.7551 13.9063 18.2357 15.0968 17.4178C16.2872 16.5998 17.2633 15.5073 17.9426 14.2327C18.6219 12.958 18.9844 11.5385 18.9995 10.0943C19.0146 8.64995 18.6819 7.22323 18.0295 5.93461C17.377 4.64599 16.424 3.53333 15.251 2.69061C14.0779 1.8479 12.7193 1.2999 11.2898 1.0929" stroke="white" stroke-width="2" stroke-linecap="round"/>
//   <path d="M19 10C19 8.55562 18.6524 7.13246 17.9865 5.85075C17.3206 4.56903 16.356 3.46641 15.1742 2.63603C13.9923 1.80565 12.628 1.2719 11.1965 1.07988C9.76492 0.887868 8.30817 1.04322 6.94931 1.53281C5.59044 2.02241 4.36937 2.83186 3.38925 3.8928C2.40913 4.95373 1.69875 6.23498 1.31812 7.6283C0.937495 9.02162 0.897806 10.4861 1.2024 11.898C1.507 13.3099 2.14694 14.6277 3.06816 15.7402" stroke="white" stroke-width="2" stroke-linecap="round"/>
// </svg>
//             </span>
//           `;
//         },
//       }}
    >

        <SwiperSlide className=''>
        <div className="">
          <Image
  src={HomeBanner1}
  alt="HomeBanner1"
  priority
  unoptimized
  quality={75}
  sizes="100vw"
  className="object-cover w-full h-full"
  placeholder="blur"
/>
          
        </div>
      </SwiperSlide>
      <SwiperSlide className=''>
        <div className=" ">
            <Image src={HomeBanner2} alt="HomeBanner2"   loading="lazy"
  quality={75}
  sizes="100vw"
  className="object-cover w-full h-full"
  placeholder="blur" />
        </div>
      </SwiperSlide>
      <SwiperSlide className=''>
        <div className="">
            <Image src={HomeBanner3} alt="HomeBanner3"   loading="lazy"
  quality={75}
  sizes="100vw"
  className="object-cover w-full h-full"
  placeholder="blur" />
        </div>
      </SwiperSlide>
          
      </Swiper>
  </div>
  <div className="new_linear">

  <div className="trusted_by container">
   <div className='flex justify-center mb-[80px] items-center gap-4'>
    <SvgIcons.Lines className='w-[50px] md:w-[86px]' />
    <h1 className="bg-gradient-to-r w-fit text-center from-[#1A5D6B] to-[#33B6D1] bg-clip-text text-transparent font-NeueMontrealBold text-[18px] md:text-4xl font-bold leading-normal">
      Trusted by Leading Brands
    </h1>
    <SvgIcons.Lines className='w-[50px] md:w-[86px]' /></div> 

    <div className="trust_img">
    <Image src={img1} alt="Clean Logo"  loading="lazy" />
    <Image src={img2} alt="Clean Logo"  loading="lazy" />
    <Image src={img3} alt="Clean Logo"  loading="lazy" />
    <Image src={img4} alt="Clean Logo"  loading="lazy" />
    <Image src={img5} alt="Clean Logo"  loading="lazy" />


    </div> 
    
    <div className="timer_sec_all !my-[40px]">
      <div className="timer_sec_1">
        <div className="timer_img">
        <Image src={cer} width={50} height={50} alt="Clean Logo" loading="lazy" />

        </div>
        <span>10+ Years</span>
        <p>Industrial Experience</p>
      </div>
      <div className="timer_sec_1">
      <div className="timer_img">
        <Image src={rocket} width={50} height={50} alt="Clean Logo" loading="lazy" />

        </div>       
         <span>500+</span>
        <p>Installations</p>
      </div>
      <div className="timer_sec_1">
      <div className="timer_img">
        <Image src={user} width={50} height={50} alt="Clean Logo" loading="lazy" />

        </div>       
         <span>50+</span>
        <p>Industrial Experts</p>
      </div>
    </div>
  </div>
  </div>

      <div className="our_reach_sec">
        <div>
          <div className='flex justify-center mb-[80px] items-center gap-4'>
            <SvgIcons.Lines className='w-[50px] md:w-[86px]' />
            <p
              className="bg-gradient-to-r w-fit text-center from-[#1A5D6B] to-[#33B6D1] bg-clip-text text-transparent font-NeueMontrealBold text-[18px] md:text-4xl font-bold leading-normal">Our Reach</p>
            <SvgIcons.Lines className='w-[50px] md:w-[86px]' /></div>
        </div>
        <div>

        </div>
        <Image src={world_img} alt="World Logo" loading="lazy" className='img-fluid md:px-0 px-3 md:pb-0 pb-5 mx-auto w-[500px]' />
      </div>

  <div className="our_products_all">
  <div className='py-0 my-0 py-md-4 my-md-4'>
            <Ourproducts/>

            </div>
  </div>


<div className="blue_background_all">

  <div className="blue_swiper  container mx-auto">
  <Swiper
        spaceBetween={30}
        centeredSlides={true}
        autoplay={{
          delay: 9500,
          disableOnInteraction: false,
        }}
        pagination={{
          clickable: true,
        }}
        navigation={true}
        modules={[Autoplay, Pagination, Navigation]}
        className="mySwiper"
      >
        <SwiperSlide className='bg-[#DEFBFF] p-[24px] rounded-[12px]'>
          <div className="flex flex-wrap -mx-3">
            <div className="w-full md:w-5/12 px-3">
              <div className="blue_swiper_left">
                <div className="blue_swipe_img">
                <Image src={homesw1} alt="Clean Logo" loading="lazy" className='img-fluid' />

                </div>
              </div>
            </div>
            <div className="w-full md:w-7/12 px-3 blue_center_div">
              <div className="blue_swiper_right">

                <p className='!text-[#0096B7] !font-bold !text-[30px]'>Laminar Airflow Benches</p>
                <p className=''> <span className='!!font-medium'>CLEANFLOW</span> assures full product protection such as basic microbial culture and not recommended for
                  operator / environment protection. Continuous flushing of the working area by a unidirectional and
                  ultra-filtered airflow allows operation in sterile and particle free conditions. The Airflow pattern
                  will be 100% supply and 0% exhaust.</p>
                <p className=''> <span className='!!font-medium'>Vertical Laminar Airflow </span> 
                 cabinets are generally used for applications like Microbiological culture and Non-hazardous analytical application.</p>
                <p className=''> <span className='!!font-medium'>Horizontal Laminar Airflow </span> 
                 cabinets are generally used for applications like Plant Tissue culture, Non-hazardous analytical applications</p>

                
                <table className="!w-full text-left border-collapse md:!w-[500px]">
                  <thead>
                    <tr className="!bg-[#1595B2]">
                      <th className="!p-2 border text-center text-white !text-[16px]">Model No</th>
                      <th className="!p-2 border text-center text-white !text-[16px]">Working sizes</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr className="border">
                      <td className="!p-[10px] text-center font-[500] border-white border !bg-[#C2F0FA]">CFV / CFH 600</td>
                      <td className="!p-[10px] text-center font-[500] border-white border !bg-[#C2F0FA]">2 x 2 x 2</td>
                    </tr>
                  </tbody>
                  <tbody>
                    <tr className="border">
                      <td className="!p-[10px] text-center font-[500] border-white border !bg-[#C2F0FA]">CFV / CFH 900</td>
                      <td className="!p-[10px] text-center font-[500] border-white border !bg-[#C2F0FA]">3 x 2 x 2</td>
                    </tr>
                  </tbody>
                  <tbody>
                    <tr className="border">
                      <td className="!p-[10px] text-center font-[500] border-white border !bg-[#C2F0FA]">CFV / CFH 1200</td>
                      <td className="!p-[10px] text-center font-[500] border-white border !bg-[#C2F0FA]">4 x 2 x 2</td>
                    </tr>
                  </tbody>
                  <tbody>
                    <tr className="border">
                      <td className="!p-[10px] text-center font-[500] border-white border !bg-[#C2F0FA]">CFV / CFH 1800</td>
                      <td className="!p-[10px] text-center font-[500] border-white border !bg-[#C2F0FA]">6 x 2 x 2</td>
                    </tr>
                  </tbody>
                </table>


                <p className='!text-[16px] !font-bold !text-[#000]'>*Customized sizes are also available</p>
                <p className='!text-[16px] !text-[#000]'>
                  Special features available such as fully automatic motorized
                  sliding front door, sensor-based digital differential pressure monitoring system,
                  PLC based control panel with feather-touch switches, etc.</p>



                <div className="blue_btn">
                  <button>View Product<SvgIcons.ViewProduct/></button>
                </div>

              </div>
            </div>

          </div>
        </SwiperSlide>

        <SwiperSlide className='bg-[#DEFBFF] p-[24px] rounded-[12px]'>
          <div className="flex flex-wrap -mx-3">
            <div className="w-full md:w-5/12 px-3">
              <div className="blue_swiper_left">
                <div className="blue_swipe_img">
                <Image src={homesw2} alt="Clean Logo" loading="lazy" className='img-fluid' />

                </div>
              </div>
            </div>
            <div className="w-full md:w-7/12 px-3 blue_center_div">
              <div className="blue_swiper_right">

                <p className='!text-[#0096B7] !font-bold !text-[30px]'>Fume Exhaust Hood</p>
                <p className=''>Cleans Fume exhaust hoods are installed in laboratories
                  to remove chemical odor, fumes and gases emitted during the process activities.
                  Cleans Fume hoods are available in various types such as constant exhaust hoods,
                  axillary bye-pass hoods and low volume exhaust hoods, etc. Cleans fume hoods are fully contained and custom-built models. Three sides of the hood are permanently closed and the front side provided with a sliding type sash made of toughened glass. Ventilated under storage cabinets are supplied along with Cleans Fume hoods for storing reagent and small instruments, etc.
                  Fume hoods are available in ducted or ductless type and also in walk-in type.</p>
                <p className='!font-bold'>Cleans Fume hoods are available:</p>
                <p className=''>
                  Powder coated galvanized iron construction with FRP/PP inner lining Polypropylene 
                  construction with PU paint coated finish IS304 SS construction. 
                </p>

                <p className='!font-bold'>Available in the following sizes :</p>

                
                <table className="!w-full text-left border-collapse md:!w-[500px]">
                  <thead>
                    <tr className="!bg-[#1595B2]">
                      <th className="!p-2 border text-center text-white !text-[16px]">Model No</th>
                      <th className="!p-2 border text-center text-white !text-[16px]">Length mm Inner/Outer</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr className="border">
                      <td className="!p-[10px] text-center font-[500] border-white border !bg-[#C2F0FA]">CFH 900</td>
                      <td className="!p-[10px] text-center font-[500] border-white border !bg-[#C2F0FA]">3x2x3</td>
                    </tr>
                  </tbody>
                  <tbody>
                    <tr className="border">
                      <td className="!p-[10px] text-center font-[500] border-white border !bg-[#C2F0FA]">CFH 1200</td>
                      <td className="!p-[10px] text-center font-[500] border-white border !bg-[#C2F0FA]">4x2x3</td>
                    </tr>
                  </tbody>
                  <tbody>
                    <tr className="border">
                      <td className="!p-[10px] text-center font-[500] border-white border !bg-[#C2F0FA]">CFH 1500</td>
                      <td className="!p-[10px] text-center font-[500] border-white border !bg-[#C2F0FA]">5x2x3</td>
                    </tr>
                  </tbody>
                  <tbody>
                    <tr className="border">
                      <td className="!p-[10px] text-center font-[500] border-white border !bg-[#C2F0FA]">CFH 1800</td>
                      <td className="!p-[10px] text-center font-[500] border-white border !bg-[#C2F0FA]">6x2x3</td>
                    </tr>
                  </tbody>
                 
                </table>


                <p className='!text-[16px] !font-bold !text-[#000]'>*Customized sizes are also available</p>
                <p className='!text-[16px] !text-[#000]'>
                  Special features available such as fully automatic motorized
                  sliding front door, sensor-based digital differential pressure monitoring system,
                  PLC based control panel with feather-touch switches, etc.</p>



                <div className="blue_btn">
                  <button>View Product<SvgIcons.ViewProduct/></button>
                </div>

              </div>
            </div>

          </div>
        </SwiperSlide>

        <SwiperSlide className='bg-[#DEFBFF] p-[24px] rounded-[12px]'>
          <div className="flex flex-wrap -mx-3">
            <div className="w-full md:w-5/12 px-3">
              <div className="blue_swiper_left">
                <div className="blue_swipe_img">
                <Image src={homesw3} alt="Clean Logo" loading="lazy" className='img-fluid' />

                </div>
              </div>
            </div>
            <div className="w-full md:w-7/12 px-3 blue_center_div">
              <div className="blue_swiper_right">

                <p className='!text-[#0096B7] !font-bold !text-[30px]'>Laboratory Modular Furnitures</p>
                <p className=''>
                  We are the leading Manufacturers in Chennai, Bangalore and Hyderabad. LAB Tables, WALL Tables, ISLAND Table,
                  INSTRUMENT Tables, L SHAPE Tables, U SHAPE Tables and Etc., Island table are ideal for working on both the
                  sides of the table, the island table will have suspended type drawer & shutter combination modules are provided
                  on the both side of the table, adjustable two tier racks are provided for keeping the reagents.</p>
                <p className=''>
                  These laboratory island tables can be fitted either to the pedestal system or to the flexible system with
                  considerable ease according to the purpose of the table as well as according to the used needs.
                  Island tables are used widely as per the need and they can accommodate the products to be installed
                  on them which can be designed and customised as per the field of usage or the user compatibility.
                  The island lab tables are fabricated by the industry grade quality materials which make them highly
                  durable and everlasting. 
                </p>
                <p className=''>
                  Laboratory instrument tables are modular type so that the modules are designed in such a way that the
                  modules can be dismantled and assembled very easily in case of maintenance if required. We lead the
                  laboratory instrument table manufacturers with superior design as well as quality products produced
                  by our industry and with doorstep delivery as well as installation. 
                </p>


                <div className="blue_btn">
                  <button>View Product<SvgIcons.ViewProduct/></button>
                </div>

              </div>
            </div>

          </div>
        </SwiperSlide>

        <SwiperSlide className='bg-[#DEFBFF] p-[24px] rounded-[12px]'>
          <div className="flex flex-wrap -mx-3">
            <div className="w-full md:w-5/12 px-3">
              <div className="blue_swiper_left">
                <div className="blue_swipe_img">
                <Image src={homesw4} alt="Clean Logo" loading="lazy" className='img-fluid' />

                </div>
              </div>
            </div>
            <div className="w-full md:w-7/12 px-3 blue_center_div">
              <div className="blue_swiper_right">

                <p className='!text-[#0096B7] !font-bold !text-[30px]'>Airflow Units</p>
                <p className=''>
                  Ceiling Suspended Laminar Air Flow system by clean flow Systems that sets a new standard for clean air quality.
                  It is designed with a strong focus on providing exceptional air purity, laminar air flow, energy efficiency,
                  and a user-friendly interface for Easy operation. </p>
                <p className=''>
                  Cleans Ceiling Suspended Laminar Airflow provides ultra clean sterile CLASS 100 clean air in specific area for
                  various kinds of critical and highly sensitive activities are carried-out such as filling, bottling, turn-table or
                  any other post- Operative health care is designed as per CLASS 5 OF ISO 14644-1 standards. Access for replacing
                  HEPA filters will be provided from the bottom. 
                </p>
                <p className=''>
                  Available in various sizes and in different type of fabrication material such as IS 304 SS, IS
                  316 SS or powder coated GSS. Cleans CLAF provided with differential pressure gauge and 
                  transparent flexible strip curtains can be provided on request. Either inbuilt or stand-alone control
                  panel with optional LED indicator provided’ Ceiling Suspended Laminar Air Flow systems for various
                  applications in the following areas: 
                </p>

                <div>
                  <ul className='!mb-2 space-y-[12px]'>
                    <li className='font-medium'>∙ Bio-Technology</li>
                    <li className='font-medium'>∙ Nano-Technology</li>
                    <li className='font-medium'>∙ R&D Laboratory </li>
                    <li className='font-medium'>∙ Electronics Manufacturing </li>
                    <li className='font-medium'>∙ Medical Industry </li>
                    <li className='font-medium'>∙ Food Processing Industry</li>
                  </ul>
                </div>


                <div className="blue_btn mt-[10px]">
                  <button>View Product<SvgIcons.ViewProduct/></button>
                </div>

              </div>
            </div>

          </div>
        </SwiperSlide>
        
      </Swiper>
  </div>

</div>






<div className="why_choose_all container mx-auto !mt-6 ">
  <div className='flex justify-center items-center mb-[20px]'>
  <p className="bg-gradient-to-r w-fit !text-center  from-[#1A5D6B] to-[#33B6D1] bg-clip-text text-transparent font-NeueMontrealBold text-[18px] md:text-4xl font-bold leading-normal">
    Why Choose Clean Flow System?
    </p>
    </div>

  <div className="choose_card_all custom-gap md:!space-y-0 !space-y-3">
    <div className="choose_card">
      <div className="smile_des">
      <SvgIcons.Puzzle />

      </div>

<p>All-in-One Convenience</p>
<p>Simplify your workflow with our Total Solutions Package—comprehensive, hassle-free, and designed just for your unique requirements.</p>
    </div>
    <div className="choose_card">
      <div className="smile_des">
      <SvgIcons.Light />

      </div>

<p>Complete Care, One Solution</p>
<p>Experience the ease of our Total Solutions Package—a fully integrated, efficient, and tailored approach to meet your every need seamlessly.</p>
    </div>
     <div className="choose_card">
      <div className="smile_des">
      <SvgIcons.Smiley />

      </div>

<p>Smart Solutions, Simplified</p>
<p>Get everything you need with our Total Solutions Package—streamlined, cost-effective, and built to fit your unique requirements.</p>
    </div>
  </div>
</div>


<div className="img_zig_zag_all my-[80px] md:my-[120px]">
<div className="zig_img container mx-auto">

  <div className="grid gap-[16px] grid-cols-2 md:!grid-cols-2 lg:!grid-cols-4">
<Image src={gallery_img1} alt="Clean Logo" loading="lazy" />
<Image src={gallery_img2} alt="Clean Logo" loading="lazy" />
<Image src={gallery_img3} alt="Clean Logo" loading="lazy" />
<Image src={gallery_img4} alt="Clean Logo" loading="lazy" />
<Image src={gallery_img5} alt="Clean Logo" loading="lazy" />
<Image src={gallery_img6} alt="Clean Logo" loading="lazy" />
<Image src={gallery_img7} alt="Clean Logo" loading="lazy" />
<Image src={gallery_img8} alt="Clean Logo" loading="lazy" />
  </div>
</div>

</div>

<div className="home_testi py-4">
<Testimonials />

</div>


  <div className="certified_by_all container mx-auto my-md-5 my-0">
    <p className='text-[18px] md:text-4xl text-black font-bold text-center mb-[30px]'>Certified By</p>
    <div className="flex items-center justify-around flex-wrap gap-[16px]">
    <Image src={certiImage1} className='w-[80px] md:w-[140px] h-[80px] md:h-[140px]' alt="Clean Logo" loading="lazy" />
    <Image src={certiImage2} className='w-[80px] md:w-[140px] h-[80px] md:h-[140px]' alt="Clean Logo" loading="lazy" />
    <Image src={certiImage3} className='w-[80px] md:w-[140px] h-[80px] md:h-[140px]' alt="Clean Logo" loading="lazy" />
    <Image src={certiImage4} className='w-[80px] md:w-[140px] h-[80px] md:h-[140px]' alt="Clean Logo" loading="lazy" />
    <Image src={certiImage5} className='w-[80px] md:w-[140px] h-[80px] md:h-[140px]' alt="Clean Logo" loading="lazy" />
    <Image src={certiImage6} className='w-[80px] md:w-[140px] h-[80px] md:h-[140px]' alt="Clean Logo" loading="lazy" />
    <Image src={certiImage7} className='w-[80px] md:w-[140px] h-[80px] md:h-[140px]' alt="Clean Logo" loading="lazy" />

    </div>
  </div>


  <div className="our_clients_all container mx-auto md:my-[120px] my-[80px]">
    <p className='text-[18px] md:text-4xl text-black font-bold text-center mb-[30px]'>Our Clients</p>
    <div className="relative w-full overflow-hidden">
  <div
    className="flex w-max animate-scroll whitespace-nowrap gap-16 px-4"
    onWheel={(e) => {
      const container = e.currentTarget;
      container.scrollLeft += e.deltaY;
    }}
  >
    {[cipla, cauvery, saint, kia, mobis, apollo, Fortis, Rela, VHS, IIT, CLRI, BioCon, divis, Aachifoods].map((logo, index) => (
      <Image
        key={index}
        className="!w-[100px] !h-[100px] !object-contain mx-auto filter grayscale"
        src={logo}
        alt="Clean Logo"
        loading="lazy"
      />
    ))}

    {/* Duplicate logos for seamless loop */}
    {[cipla, cauvery, saint, kia, mobis, apollo, Fortis, Rela, VHS, IIT, CLRI, BioCon, divis, Aachifoods].map((logo, index) => (
      <Image
        key={`copy-${index}`}
        className="!w-[100px] !h-[100px] !object-contain mx-auto filter grayscale" 
        src={logo}
        alt="Clean Logo"
        loading="lazy"
      />
    ))}
  </div>
</div>
  </div>

 
  
  
  </>
  );
};

export default Homepage;
